/* ============================================================
   FA Cart Summary — fa-cart-summary.js
   Ship/Pickup toggle + ZIP shipping calculator
   ============================================================ */
(function () {
  'use strict';

  var LS_KEY = 'fa_fulfil_mode'; // 'ship' or 'pickup'

  /* ── Elements ── */
  var btnShip, btnPickup, zipWrap, pickupNotice, shippingRow, shippingVal, zipResult, zipBtn;

  /* ── Set fulfillment mode ── */
  function setMode(mode) {
    var isShip = mode === 'ship';

    btnShip.classList.toggle('is-active', isShip);
    btnPickup.classList.toggle('is-active', !isShip);
    btnShip.setAttribute('aria-pressed', isShip ? 'true' : 'false');
    btnPickup.setAttribute('aria-pressed', !isShip ? 'true' : 'false');

    if (isShip) {
      zipWrap.style.display = '';
      pickupNotice.hidden = true;
      shippingRow.style.display = '';
    } else {
      zipWrap.style.display = 'none';
      pickupNotice.hidden = false;
      shippingRow.style.display = 'none';
    }

    try { localStorage.setItem(LS_KEY, mode); } catch (e) {}
  }

  /* ── ZIP calculator ── */
  function calculateShipping() {
    var zip = document.getElementById('fa-zip-input').value.trim();
    var state = document.getElementById('fa-zip-state').value;

    if (!zip) {
      showResult('Please enter a ZIP code.', 'is-error');
      return;
    }
    if (!state) {
      showResult('Please select your state.', 'is-error');
      return;
    }

    zipBtn.classList.add('is-loading');
    zipBtn.textContent = '...';
    zipResult.className = 'fa-summary__zip-result';
    zipResult.textContent = 'Calculating\u2026';

    var url = '/cart/shipping_rates.json'
      + '?shipping_address[zip]=' + encodeURIComponent(zip)
      + '&shipping_address[country]=US'
      + '&shipping_address[province]=' + encodeURIComponent(state);

    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var rates = data.shipping_rates;

        if (!rates || !rates.length) {
          showResult('No rates found. Try a different address.', 'is-error');
          shippingVal.textContent = 'Unavailable';
          shippingVal.className = 'fa-summary__totals-val';
          return;
        }

        // Sort cheapest first
        rates.sort(function (a, b) { return parseFloat(a.price) - parseFloat(b.price); });
        var cheapest = rates[0];
        var price = parseFloat(cheapest.price);

        if (price === 0) {
          showResult('\u2713 Free shipping available to ' + zip + ', ' + state, 'is-free');
          shippingVal.textContent = 'Free';
          shippingVal.className = 'fa-summary__totals-val is-free';
        } else {
          var allRates = rates.map(function (r) { return r.name + ' \u00b7 $' + parseFloat(r.price).toFixed(2); }).join('  \u2022  ');
          showResult(allRates, '');
          shippingVal.textContent = 'from $' + price.toFixed(2);
          shippingVal.className = 'fa-summary__totals-val is-calculated';
        }

        // Save last used ZIP/state for re-use on cart updates
        try {
          localStorage.setItem('fa_zip', zip);
          localStorage.setItem('fa_state', state);
        } catch (e) {}
      })
      .catch(function () {
        showResult('Could not calculate. Please try again.', 'is-error');
      })
      .finally(function () {
        zipBtn.classList.remove('is-loading');
        zipBtn.textContent = 'Calculate';
      });
  }

  function showResult(text, cls) {
    zipResult.textContent = text;
    zipResult.className = 'fa-summary__zip-result' + (cls ? ' ' + cls : '');
  }

  /* ── Restore saved ZIP on load ── */
  function restoreSaved() {
    try {
      var savedZip = localStorage.getItem('fa_zip');
      var savedState = localStorage.getItem('fa_state');
      if (savedZip) document.getElementById('fa-zip-input').value = savedZip;
      if (savedState) document.getElementById('fa-zip-state').value = savedState;
      // Auto-recalculate if we have a saved address
      if (savedZip && savedState) calculateShipping();
    } catch (e) {}
  }

  /* ── Re-render breakdown when Horizon updates cart ── */
  function refreshBreakdown() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var breakdown = document.getElementById('fa-summary-breakdown');
        if (!breakdown) return;

        var label = breakdown.querySelector('.fa-summary__breakdown-label');
        var html = label ? label.outerHTML : '<p class="fa-summary__breakdown-label">Order Summary</p>';

        cart.items.forEach(function (item) {
          var hasDiscount = item.original_line_price !== item.final_line_price;
          var qty = item.quantity;
          var qtyLabel = qty + (qty === 1 ? ' box' : ' boxes');

          // Collect discount titles
          var discountTitles = '';
          if (item.line_level_discount_allocations && item.line_level_discount_allocations.length) {
            var titles = item.line_level_discount_allocations.map(function (d) {
              return d.discount_application ? d.discount_application.title : '';
            }).filter(Boolean);
            if (titles.length) discountTitles = ' \u00b7 ' + titles[0].slice(0, 18);
          }

          var priceHTML = hasDiscount
            ? '<span class="fa-summary__line-orig">' + money(item.original_line_price) + '</span>'
              + '<span class="fa-summary__line-price is-sale">' + money(item.final_line_price) + '</span>'
            : '<span class="fa-summary__line-price">' + money(item.final_line_price) + '</span>';

          var title = item.product_title.length > 28
            ? item.product_title.slice(0, 27) + '\u2026'
            : item.product_title;

          html += '<div class="fa-summary__line">'
            + '<div class="fa-summary__line-info">'
            + '<span class="fa-summary__line-name">' + title + '</span>'
            + '<span class="fa-summary__line-qty">' + qtyLabel + discountTitles + '</span>'
            + '</div>'
            + '<div class="fa-summary__line-prices">' + priceHTML + '</div>'
            + '</div>';
        });

        breakdown.innerHTML = html;

        // Update savings row
        var savingsRow = document.querySelector('.fa-summary__totals-row.is-savings');
        if (savingsRow) {
          if (cart.total_discount > 0) {
            savingsRow.style.display = '';
            var valEl = savingsRow.querySelector('.fa-summary__totals-val');
            if (valEl) valEl.textContent = '\u2212' + money(cart.total_discount);
          } else {
            savingsRow.style.display = 'none';
          }
        }
      })
      .catch(function () {});
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ── Init ── */
  document.addEventListener('DOMContentLoaded', function () {
    var root = document.getElementById('fa-cart-summary');
    if (!root) return;

    btnShip = document.getElementById('fa-fulfil-ship');
    btnPickup = document.getElementById('fa-fulfil-pickup');
    zipWrap = document.getElementById('fa-summary-zip');
    pickupNotice = document.getElementById('fa-summary-pickup');
    shippingRow = document.getElementById('fa-shipping-row');
    shippingVal = document.getElementById('fa-shipping-val');
    zipResult = document.getElementById('fa-zip-result');
    zipBtn = document.getElementById('fa-zip-calc');

    // Restore saved mode
    var savedMode = 'ship';
    try { savedMode = localStorage.getItem(LS_KEY) || 'ship'; } catch (e) {}
    setMode(savedMode);

    // Restore saved ZIP and auto-calc if mode is ship
    if (savedMode === 'ship') restoreSaved();

    // Toggle buttons
    btnShip.addEventListener('click', function () { setMode('ship'); });
    btnPickup.addEventListener('click', function () { setMode('pickup'); });

    // ZIP calc on button click
    zipBtn.addEventListener('click', calculateShipping);

    // ZIP calc on Enter key
    document.getElementById('fa-zip-input').addEventListener('keydown', function (e) {
      if (e.key === 'Enter') calculateShipping();
    });

    // Listen for Horizon cart updates and refresh breakdown
    var cartTable = document.querySelector('.cart-items__table');
    if (cartTable) {
      var obs = new MutationObserver(function () {
        clearTimeout(cartTable._summaryTimer);
        cartTable._summaryTimer = setTimeout(refreshBreakdown, 200);
      });
      obs.observe(cartTable, { childList: true, subtree: true });
    }
  });
})();